define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/locale",
	"csi/xml",
	"csi/xml/Query"
], function(array, declare, lang, def, Field, Relationship, Widget, locale, xml, Query) {

	return declare(Widget, {

		_resolveView: function() {
			this.defView.m_fields.splice(1, 0, (lang.mixin(new Field(), {
				m_label: "To",
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_bRequired: true,
				idParameter: "To",
				m_relationship: lang.mixin(new Relationship(), {
					m_url: this.getViewURL(),
					m_id: "ProductColors",
					m_query: new Query().Attr("Active", xml.OP_EQUALS, true)
				})
			})));
			this.inherited(arguments);
		},

		_buildView: function() {
			var productColors = this.getCache().getChildren(this.getViewNode(), "ProductColors");
			var productColorsForSpec = array.filter(productColors, function(item) {
				return item.Active == true && (item.ColorSpecification == this.getFormSourceNode().$URL || item.ColorSpecification == this.getFormSourceNode().ColorSpecification);
			}, this);

			if (productColorsForSpec.length > 0) {
				this.addDefaultValue("To", productColorsForSpec[0].$URL);
			}
			this.inherited(arguments);
		}

	});
});